import React from "react";
import { CgTranscript } from "react-icons/cg";
import { FaFilePdf } from "react-icons/fa6";
import { GrBlog } from "react-icons/gr";
import { MdOutlineForum } from "react-icons/md";
import { TbFileUnknown } from "react-icons/tb";
import { BiMailSend } from "react-icons/bi";

export const getIcon = (
  shortCode: string,
): { alt: string; i: React.ReactNode } => {
  switch (shortCode) {
    case "R":
      return {
        alt: "Document",
        i: <FaFilePdf className="ml-1 text-red-500" size={18} />,
      };
    case "B":
      return {
        alt: "Blog",
        i: <GrBlog className="ml-1 text-blue-500" size={18} />,
      };
    case "T":
      return {
        alt: "Transcript",
        i: <CgTranscript className="ml-1 text-orange-500" size={18} />,
      };
    case "F":
      return {
        alt: "Forum",
        i: <MdOutlineForum className="ml-1 text-green-500" size={18} />,
      };
    case "A":
      return {
        alt: "Article",
        i: <BiMailSend className="ml-1 text-blue-600" size={18} />,
      };
    default:
      return {
        alt: "Unidentified",
        i: <TbFileUnknown className="ml-1" size={18} />,
      };
  }
};
